import { GamseContainer } from "../containers/games"

export const Games = () => {
    return (
        <GamseContainer />
    )
}